import { ServiceMaker, methods, services } from "../services";
import Api from "@/services/service-v2";

export const getItemStockStatus = (Id, data) =>
  ServiceMaker(
    `/inventory/stock-status/${Id}`,
    methods.POST,
    services.inventory,
    data
  );

export const getItemStockDownload = (Id) =>
  ServiceMaker(
    `/inventory/stock-status/${Id}?download=true`,
    methods.GET,
    services.inventory
  );

export const downloadInventoryTemplate = (Id) =>
  ServiceMaker(
    `/inventory/template/${Id}`,
    methods.GET,
    services.inventory,
    null,
    true
  );

export const uploadFileToStorage = (data) =>
  ServiceMaker(`file/upload`, methods.POST, services.storage, data);

export const uploadVideoToStorage = (data) =>
  ServiceMaker(`file/upload`, methods.POST, services.storage, data);

export const deleteFileFromStorage = (data) =>
  ServiceMaker(`file/delete`, methods.POST, services.storage, data);

export const uploadImageToStorage = (data) =>
  ServiceMaker(`image/upload`, methods.POST, services.storage, data);

// export const uploadVideoToStorage = (data) => ServiceMaker(`file/upload`, methods.POST, services.storage, data);

export const loadInventory = (data) =>
  ServiceMaker(
    "/inventory/load-inventory",
    methods.POST,
    services.inventory,
    data
  );

export const loadInventorySeed = (data) =>
  ServiceMaker(
    "/inventory/load-inventory/seed",
    methods.POST,
    services.inventory,
    data
  );

export const updateInventory = (data) =>
  ServiceMaker(
    "/inventory/stock-update",
    methods.POST,
    services.inventory,
    data
  );

export const transferInventory = (data) =>
  ServiceMaker(
    "/inventory/stock-transfer",
    methods.POST,
    services.inventory,
    data
  );

export const inventoryUpdateHistory = () =>
  ServiceMaker("/inventory/update-history", methods.GET, services.inventory);

export const getAllStockStatus = (data) =>
  ServiceMaker(
    "/inventory/stock-status/all",
    methods.POST,
    services.inventory,
    data
  );

export const inventoryOrderReport = (payload) =>
  Api().$http.post(`/order/api/v1/get/order-report`, payload);

export const stockDetails = (data) =>
  Api().$http.get(
    `/order/api/v1/get/order-details/${data.providerId}/${data.itemId}?&fromDate=${data.fromDate}&toDate=${data.toDate}`
  );

export const inventoryOrderStatus = (payload) =>
  Api().$http.post(`/store/inventory/list-stock`, payload);

export const quickTransferInventory = (payload) =>
  Api().$http.post(`/store/inventory/quick-stock-transfer`, payload);
